module.exports = __webpack_public_path__ + "images/emoji/m.23befb9cc862a61c86c2.png";